import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toHandlerKey as _toHandlerKey, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-336ae3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "screen-reader" }
const _hoisted_4 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.display)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal",
            ref: "modal",
            [_toHandlerKey(_ctx.backdropEvent)]: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close()), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.allowExit && _ctx.showExit)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    role: "button",
                    class: "close",
                    title: _ctx.btnCloseTitle,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                  }, [
                    _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
                      [_directive_translate, `general.modal_close`]
                    ])
                  ], 8, _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ])
          ], 16))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}